import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Loader, Button } from '@getro/rombo';
import { IntroPathCard } from './IntroPathCard';
import { useIntroPaths } from './hooks/useIntroPaths';
import { trackEvent } from '../../../helpers/analytics';
import { getContactDisplayName } from '../../../helpers/getContactDisplayName';

export const IntroPaths = ({ network, contact }) => {
  const { data = [], isLoading, isSuccess, showAll, setShowAll, itemsToRender, hasMore } = useIntroPaths({ contact });

  useEffect(() => {
    if (isSuccess) {
      trackEvent('contacts:intro_paths:view', {
        contactId: contact.id,
        collectionId: network?.id,
        pathCount: data.length,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center" py="24px">
        <Loader />
      </Flex>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Text fontSize="14px" color="text.main">
        There are no signals that suggest your team can reach {getContactDisplayName(contact, 'this contact')}.
      </Text>
    );
  }

  return (
    <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
      <Box>
        <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
          {itemsToRender.map((item) => (
            <IntroPathCard key={item.id} network={network} item={item} />
          ))}
        </Flex>
      </Box>

      {hasMore && (
        <Box textAlign="center" pt="16px">
          {!showAll && (
            <Button variant="secondary" size="small" onClick={() => setShowAll(true)}>
              View more
            </Button>
          )}
        </Box>
      )}
    </Flex>
  );
};

IntroPaths.propTypes = {
  contact: PropTypes.object.isRequired,
  network: PropTypes.object.isRequired,
};
